import React from 'react';
import { DollarSign, UtensilsCrossed, MessageCircle, FileCheck } from 'lucide-react';
const features = [{
  icon: DollarSign,
  title: 'Контроль над деньгами',
  color: 'bg-[#EDE7F6] text-[#7C4DFF]'
}, {
  icon: UtensilsCrossed,
  title: 'Контроль над продуктами питания',
  color: 'bg-[#E8F5E9] text-[#43A047]'
}, {
  icon: MessageCircle,
  title: 'Контроль над коммуникацией с родителями',
  color: 'bg-[#E3F2FD] text-[#1E88E5]'
}, {
  icon: FileCheck,
  title: 'Автоматическая генерация документов',
  color: 'bg-[#FFF3E0] text-[#F57C00]'
}];
export function WhatIsMeeloSection() {
  return <section className="py-24 bg-white" id="what-is-meelo" data-id="element-207">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-208">
        <div className="text-center mb-16" data-id="element-209">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A2E]" data-id="element-210">
            Что такое Meelo?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8" data-id="element-211">
          {features.map((feature, index) => <div key={index} className="bg-[#FAFAFA] rounded-2xl p-8 text-center border border-gray-100" data-id="element-212">
              <div className={`w-14 h-14 rounded-full ${feature.color} flex items-center justify-center mx-auto mb-6`} data-id="element-213">
                <feature.icon size={26} strokeWidth={1.8} data-id="element-214" />
              </div>
              <h3 className="text-lg font-semibold text-[#1A1A2E] leading-snug" data-id="element-215">
                {feature.title}
              </h3>
            </div>)}
        </div>
      </div>
    </section>;
}